import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import LongdoMap from 'longdo-map-vue'
Vue.config.productionTip = false
Vue.use(LongdoMap, {
  load: {
    apiKey: "rvp-dashboard"
  }
})
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
